import script from "./CompaintInfoCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompaintInfoCard.vue?vue&type=script&setup=true&lang=js"

import "./CompaintInfoCard.vue?vue&type=style&index=0&id=4fb13770&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fb13770"]])

export default __exports__